import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    padding: '35px 20px',
    fontSize: '12pt',
    '& .phrase': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: 5,
      marginRight: 5,
      '&:last-child': {
        marginLeft: 0
      }
    },
    '& .input': {
      border: 'none',
      borderBottom: 'solid 1px black',
    },
  },
}))

export {useStyles as default}
